import React, { useState, useRef } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

export default function NotificationModal(props) {
  const titleInputRef = useRef();
  const bodyInputRef = useRef();

  const [state, setState] = useState({});

  const handleConfirm = async () => {
    if (!titleInputRef.current.value) {
      setState((s) => ({
        ...s,
        errors: {
          title: "Title is required.",
        },
      }));
      return;
    }

    if (!bodyInputRef.current.value) {
      setState((s) => ({
        ...s,
        errors: {
          body: "Body is required.",
        },
      }));
      return;
    }

    setState((s) => ({
      ...s,
      isLoading: true,
      errors: undefined,
    }));
    const body = {
      userId: props.user.id,
      title: titleInputRef.current.value,
      body: bodyInputRef.current.value,
    };
    await props.handleConfirm(body);
    props.handleClose();
  };

  return (
    <Dialog
      open={true}
      onClose={props.handleClose}
      PaperProps={{
        style: {
          backgroundColor: "#d8c8f4",
          color: "#4b445b",
        },
      }}
    >
      <DialogTitle>Send Custom Notification</DialogTitle>
      <DialogContent>
        <TextField
          autoComplete="off"
          margin="dense"
          id="title"
          label="Title"
          type="text"
          fullWidth
          variant="outlined"
          inputRef={titleInputRef}
          defaultValue={state.title}
          required
          error={!!state.errors?.title}
          helperText={state.errors?.title}
        />
        <TextField
          autoComplete="off"
          margin="dense"
          id="body"
          label="Body"
          type="text"
          fullWidth
          variant="outlined"
          inputRef={bodyInputRef}
          defaultValue={state.body}
          multiline
          rows={6}
          required
          error={!!state.errors?.body}
          helperText={state.errors?.body}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} variant="contained">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={state.isLoading}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
